import * as yup from 'yup'

export const ValidationSchema = yup.object().shape({
  cooperative_name: yup
    .string()
    .max(30, 'Máximo de 30 caracteres.')
    .required('Informe o nome da coopertiva.')
})
